<template>
  <v-dialog v-model="show" persistent max-width="360">
    <v-card>
      <v-card-title>
        {{ $t('organization_settings.create_api_key') }}
      </v-card-title>

      <v-card-text v-if="apiKey">
        <p>{{ $t('organization_settings.api_key_generated_key_warning') }}</p>
        <v-textarea
          autofocus
          auto-grow
          hide-details
          class="mt-8"
          data-private
          dense
          readonly
          outlined
          data-tourid="apikeys-textField-apikey"
          :value="apiKey"
          :label="$t('organization_settings.api_key_api_key')"
          >{{ apiKey }}</v-textarea
        >

        <div class="d-flex justify-end mt-2">
          <Button
            color="primary"
            :text="$t('common.button.copy_to_clipboard')"
            @click="copyToClipboard(apiKey)"
          />
        </div>
      </v-card-text>

      <v-card-actions class="justify-end">
        <Button
          color="grey"
          plain
          :text="$t('common.button.close')"
          @click="$emit('close')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'
export default {
  name: 'APIKeysResultModal',
  components: {
    Button,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    apiKey: {
      type: String,
      required: false,
    },
  },

  methods: {
    async copyToClipboard(string) {
      await navigator.clipboard.writeText(string)
    },
  },
}
</script>
